import { Injectable } from '@angular/core';
import { HelperService } from './helper.service';
import { Subject } from 'rxjs';
import { EbookHelperService } from './ebook-helper.service';
import { DownloadHelperService } from './download-helper.service';
import { DesktopDatabaseHelperService } from './desktop-database-helper.service';
@Injectable()
export class UmbrellaService {

    // stores the modeled / modified umbrella bundles -> products
    umbrellaList;
    unfilteredUmbrellaListMap = {};
    
    private manifestChangedNotifier = new Subject<any>();
    manifestChangeObservable$ = this.manifestChangedNotifier.asObservable();


    constructor(
        private helperService: HelperService,
        private ebookHelperService: EbookHelperService,
        private desktopDatabaseHelperService: DesktopDatabaseHelperService,
        private downloadHelperService: DownloadHelperService,
    ) {

    }

    //Get umbrella bundles Data from Product Code
    public getUmbrellaofProduct(productcode) {
        return this.umbrellaList.find((bundle) => { return bundle.products.some((product) => { return product['dls-product'].code == productcode }) });
    }

    // return bundles from bundles list matching the bundle-code.
    public async fetchBundleByBundleCode(bundleCode){
        let bundles = await this.getTeacherBundlesData(false);  
        let myBundle = bundles.find((bundle) => (bundle['bundle-code'] == bundleCode));

        this.getManifests(myBundle);
        return myBundle;
    }

    // get manifests of all the ebooks in a bundle
    public async getManifests(bundle) {

        if (bundle && bundle.products) {
            let productMap = {};
            let options: any = {
                /* "baseURL" : config.app.zipCdn.baseUrl, */
                "books": []
            };

            bundle.products.forEach(product => {
                if (product['ext-product'].type == 'imgbook') {
                    productMap[product['dls-product'].code] = {
                        "bundleCode": bundle['bundle-code'],
                        "product": product
                    };
                }
            });

            if (productMap && Object.keys(productMap).length) {
                Object.keys(productMap).forEach((bookCode) => {
                    options.books.push({
                        "bookCode": bookCode,
                        "bundleCode": productMap[bookCode].bundleCode
                    });
                });

                try {
                    let data = await this.ebookHelperService.fetchManifests(options);

                    Object.keys(productMap).forEach((productcode) => {

                        if (data && data[productcode] && data[productcode].manifest && data[productcode].manifest.shared) {

                            let linkedPEs = data[productcode].linkedPEs;
                            let loManifests = data[productcode].loManifest;
                            let hasValidPEManifests = false;

                            if ((!linkedPEs && !loManifests) || (linkedPEs && loManifests && linkedPEs.length && Object.keys(loManifests).length == linkedPEs.length)) {
                                hasValidPEManifests = true;
                            }

                            let manifest = data[productcode].manifest;
                            let { fileSize, version, fileSizeUnit, unZippedFileSize, unZippedFileSizeUnit } = this.ebookHelperService.calculateManifestSize(manifest, loManifests);



                            // DB uupdate required ONLY for two conditions  - manifest node is not present (fallback), version is outdated (i.e., a new published product is present)
                            //The manifest should consist of unzip size 
                            if (manifest.shared.fileSize.unzip && (!productMap[productcode].product.manifest || productMap[productcode].product.manifest.versions != version)) {
                                productMap[productcode].product.manifest = { fileSize, version, fileSizeUnit, unZippedFileSize, unZippedFileSizeUnit, hasValidPEManifests };
                            }else{
                                // if the manifest call does not have unzip size
                                productMap[productcode].product['manifestCallFail'] = true;
                            }
                        }else{
                            // checking if the manifest call failed
                            productMap[productcode].product['manifestCallFail'] = true;
                        }
                        
                    });

                    this.manifestChangedNotifier.next(productMap);

                    if (data) {
                        let modeledData = [];
                        Object.keys(data).forEach(key => {
                            modeledData.push({ 'ebookCode': key, 'data': data[key] })
                        });
                        this.downloadHelperService.updateBookAndPEMap(modeledData);
                        this.downloadHelperService.initiateAutoUpdateProcess(modeledData);
                    }
                    
                } catch (err) {
                    console.log("Error while fetching manifests", err);
                }
                
            }
        }
    }
    
    // function to modify the Umbrellas data as required.
    private modelUmbrellaData(bundles) {
        let bundleData = [];
        bundles.forEach(bundle => {
            let containsExpiredNonDownloadedPPlusBook = false;
            let bundleEbooks: Array<Ebook> = bundle.data.products.reduce((transformedEbookData, product) => {
                if (product["ext-product"].type == "imgbook" && this.helperService.isProductActive(product)) {
                    // store only products that are ebooks and entitled(in case they are gated)
                    if(!product.isExpired || (product.isExpired && this.downloadHelperService.getDownloadedInfoForUser(product['dls-product'].code) )) {
                        transformedEbookData.push(product);
                    } else if (product.isExpired && this.downloadHelperService.getPausedInfoForUser(product['dls-product'].code)) {
                        this.downloadHelperService.removeDownload({
                            productCode: product['dls-product'].code,
                            status: 'inProcess',
                            product: product
                        });
                    }
                } else if(product["ext-product"].type == "OLP") {
                    transformedEbookData.push(product);
                }

                if(product && product.isExpired && !this.downloadHelperService.getDownloadedInfoForUser(product['dls-product'].code) && product.meta && (product.meta['cup-pplus-component'] || product.meta['pplus-component'])) {
                    containsExpiredNonDownloadedPPlusBook = true;
                }

                return transformedEbookData;
            }, []);


            // filter out pplus components if even 1 book is expired.
            if (containsExpiredNonDownloadedPPlusBook) {

                bundleEbooks = bundleEbooks.filter(book => {
                    let isPPlusComponent = book.meta && (book.meta['cup-pplus-component'] || book.meta['pplus-component']);
                    return isPPlusComponent != true;
                });

            }

            let containsValidEbook = false;

            bundleEbooks.forEach(ebook => {
                if (ebook["ext-product"].type == "imgbook") {
                    containsValidEbook = true;
                }
            })


            //If the bundle has ebook Product, then only insert that bundle-{ebook} data
            if (bundleEbooks.length && containsValidEbook) {
                let transformedBundleData = { ...bundle.data };
                transformedBundleData.imageURL = this.helperService.fetchBundleImage(bundle.data);
                transformedBundleData.products = bundleEbooks;

                bundleData.push(transformedBundleData);
            }
        });

        //If any {bundle-{ebook}} data exist then save the list of ebooks for teacher
        // bundleData.length ? await DLS_IPCCallers.SET_UMBRELLAS(bundleData) : '';

        return bundleData;
    }

    // filter out non imgbook ebooks from Umbrella and save the remaining to DB.
    async filterAndSaveUmbrellasToDB(filteredBundles, updateDB = false) {

        // store these bundles in DB.
        await this.desktopDatabaseHelperService.setOriginalUmbrellaData(filteredBundles, updateDB);

    }

    public filterUmbrellasWithoutEbooks(bundles) {

    	// filtering of bundles is no longer required as we are getting filtered bundles from the server.

        let dbData = [];
        if (bundles.length) {
            bundles.forEach(bundle => {
                dbData.push({
                    umbrellaCode: bundle['bundle-code'],
                    data: bundle
                });
            });
        }
        return dbData;

    }

    // get saved Umbrellas from DB.
    public async fetchSavedUmbrellasFromDB() {

        //Get Data from DB
        let umbrellas = await this.desktopDatabaseHelperService.getOriginalUmbrellaData();
        return umbrellas;
    }

    // get Umbrellas from DB, modify them and return.
    public transformUmbrellasData(umbrellaData) {
        this.umbrellaList = this.modelUmbrellaData(umbrellaData);
        return this.umbrellaList;
    }

    // get teacher books saved in memory in service. 
    public async getTeacherBundlesData(getOriginal = false) {
        if (getOriginal) {
            let umbrellas = await this.desktopDatabaseHelperService.getOriginalUmbrellaData();
            return umbrellas;
        } else {
            return this.umbrellaList;
        }
    }

    // reset the teacher books saved in memory.
    public resetLocalCache(resetOriginal = true) {
        if (resetOriginal) {
            this.desktopDatabaseHelperService.resetOriginalData(this.desktopDatabaseHelperService.DATAKEYS.UMBRELLAS);
        }
        this.umbrellaList = undefined;
    }

}

export interface Ebook {
    title: string,
    image: string,
    productcode: string,
    ebookpath?: string,
    description?: string,
    meta?: object,
}